import { useContext, useEffect, useState } from 'react';

import { useLocation, useNavigate } from 'react-router';

import Loading from '../../../Components/Loading/Loading';
import Pagination from '../../../Components/Pagination/Pagination';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { countOfRecourd } from '../../../Utils/Helpers';
import { GymContext } from '../Context/GymContext';

const GymList = () => {
  const context = useContext(GymContext);
  const [loading, setLoading] = useState(true);
  const { search } = useLocation();
  const { error } = useToast();
  const { get } = useApi();
  const [filter, setFilter] = useState({
    province: null,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const getData = async () => {
      await getGyms();
      await getProvinces();
    };
    getData();
  }, [search]);

  const getGyms = async () => {
    setLoading(true);
    await get(
      `/gym/list/${search}`,
      (res) => {
        context.gyms = res;
      },
      (err) => {
        error('خطا در دریافت اطلاعات');
        setLoading(false);
      },
    );
  };

  const getProvinces = async () => {
    setLoading(true);
    await get(
      `/province`,
      (res) => {
        context.provinces = res.data;
        setLoading(false);
      },
      (err) => {
        error('خطا در دریافت اطلاعات');
        setLoading(false);
      },
    );
  };

  const onChangeFilter = (name, value) => {
    setFilter((preveFilter) => {
      return { ...preveFilter, [name]: value };
    });
  };

  const submitFilter = () => {
    let queryString = '';
    queryString = search?.replace(
      new RegExp(/([(\?|\&)]+)province=([0-9]+)/, 'g'),
      '',
    );
    queryString += search?.length > 0 ? '&' : '';
    queryString += 'province=' + filter?.province;
    navigate(`/gym/list?${queryString}`);
  };

  return loading ? (
    <Loading />
  ) : (
    <Master
      showSidebar={false}
      headerFixed={true}
      containerFullWidth={true}
      title='لیست زورخانه ها'
    >
      <section className='image-cover pt-4'>
        <div className='container py-3 bg-sky-light shadow-sm rounded-1'>
          <div className='row mx-2'>
            <div className='col-12 border-bottom border-white'>
              <h1 className='text-dark f-14 font-weight-bold'>
                لیست زورخانه ها
              </h1>
            </div>
            <div className='col-12 my-2'>
              <div className='row'>
                <div className='col-12 col-md-3'>
                  <div className='form-group'>
                    <label className='f-13 text-dark text-left d-flex flex-row justify-content-start'>
                      استان
                    </label>
                    <select
                      name='province'
                      onChange={(e) =>
                        onChangeFilter('province', e.target.value)
                      }
                      value={filter?.province}
                      className='form-control'
                    >
                      <option selected={true} disabled={true}>
                        انتخاب کنید
                      </option>
                      <option value='all'>همه</option>
                      {context?.provinces?.map((province) => (
                        <option value={province?.id}>{province?.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className='col-12'>
                  <div className='form-group'>
                    {loading ? (
                      <button className='btn bg-persian-green f-12 text-white py-2 px-3'>
                        <div
                          className='spinner-border text-white spinner-border-sm mb-1'
                          role='status'
                        >
                          <span className='sr-only'></span>
                        </div>
                      </button>
                    ) : (
                      <button
                        type='button'
                        onClick={submitFilter}
                        className='btn f-12 bg-persian-green text-white py-2 px-3'
                      >
                        جستجو
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 overflow-auto'>
              {context.gyms?.data?.length > 0 ? (
                <table
                  className='table table-striped my-3 text-left'
                  style={{ minWidth: '992px' }}
                >
                  <thead>
                    <tr className='bg-purple text-white'>
                      <th scope='col'>#</th>
                      <th scope='col'>نام زورخانه</th>
                      <th scope='col'>استان</th>
                      <th scope='col'>شهر</th>
                      <th scope='col'>کد پستی</th>
                      <th scope='col'>آدرس</th>
                      <th scope='col'>تلفن</th>
                    </tr>
                  </thead>
                  <tbody>
                    {context?.gyms?.data?.map((gym, index) => (
                      <tr>
                        <td>
                          {countOfRecourd(
                            index,
                            context?.gyms?.meta?.pagination?.per_page,
                            context?.gyms?.meta?.pagination?.current_page,
                          )}
                        </td>
                        <td>{gym?.name}</td>
                        <td>{gym?.province?.name}</td>
                        <td>{gym?.city?.name}</td>
                        <td>{gym?.zip_code}</td>
                        <td>{gym?.address}</td>
                        <td>{gym?.phone}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p className='w-100 f-14 font-weight-bold text-center my-3 text-secondary'>
                  اطلاعاتی جهت نمایش یافت نشد
                </p>
              )}
            </div>
            {context?.gyms?.meta?.pagination?.total_pages > 1 && (
              <div className='col-12'>
                <Pagination
                  totalPage={context?.gyms?.meta?.pagination?.total_pages}
                  basePath='/gym/list'
                  search={search}
                />
              </div>
            )}
          </div>
        </div>
      </section>
    </Master>
  );
};

export default GymList;
